import { getCookieDomain, getCookieDomainDeprecated } from "@linkfluence/konf";
import { remove, set, string } from "@tootools/cookies";

const AUTH_TOKEN = "oauthToken";

const REFRESH_TOKEN = "oauthRefreshToken";

const EXPIRATION = 7;

const cookieDomain = getCookieDomain();
const isDevDomain = !cookieDomain || cookieDomain === "localhost";

const baseOption: Cookies.CookieAttributes = {
  domain: cookieDomain,
  sameSite: isDevDomain ? "Lax" : "None",
  secure: isDevDomain ? false : true,
};

// Previously used baseOption, to keep track of old cookies
const baseOptionDeprecated = {
  domain: getCookieDomainDeprecated(),
};

export function getAuthToken() {
  return string(AUTH_TOKEN);
}

export function getRefreshToken() {
  return string(REFRESH_TOKEN);
}

export function setAuthToken(token: string) {
  return set(AUTH_TOKEN, token, {
    ...baseOption,
    expires: EXPIRATION,
  });
}

export function setRefreshToken(token: string) {
  return set(REFRESH_TOKEN, token, {
    ...baseOption,
    expires: EXPIRATION,
  });
}

function cleanDeprecatedTokens() {
  if (isDevDomain) {
    return;
  }

  remove(REFRESH_TOKEN, baseOptionDeprecated);
  remove(AUTH_TOKEN, baseOptionDeprecated);
}

export function cleanTokens() {
  cleanDeprecatedTokens();

  // Clean current tokens
  remove(REFRESH_TOKEN, baseOption);
  return remove(AUTH_TOKEN, baseOption);
}

export function isAuthenticated() {
  cleanDeprecatedTokens();

  return getAuthToken() !== "";
}
